import { useEffect, useMemo, useState } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

import { FALSE_KEY,TRUE_KEY } from '@/common/constants';
import { Option, OptionKey, PaginationParams } from '@/common/types';

const ALL_KEY = 'ALL';

const LIMITED_FILTER_OPTIONS: Option[] = [
  { key: ALL_KEY, value: 'All' },
  { key: TRUE_KEY, value: 'Yes' },
  { key: FALSE_KEY, value: 'No' },
];

const useSearchParams = () => {
  const [limitedFilter, setLimitedFilter] = useState<OptionKey | null>(ALL_KEY);
  const { page, setPage, setPerPage, perPage, searchString, setSearchString, currentSearch } =
    usePaginationParams(10);

  const isLimitedUse = useMemo(() => {
    if (limitedFilter === TRUE_KEY) return true;
    if (limitedFilter === FALSE_KEY) return false;
    return undefined;
  }, [limitedFilter]);

  const params = useMemo<PaginationParams>(
    () => ({
      searchString: currentSearch,
      page: currentSearch ? 0 : page,
      perPage,
    }),
    [currentSearch, page, perPage]
  );

  useEffect(() => {
    setPage(1);
  }, [limitedFilter, setPage, currentSearch]);

  return {
    page,
    setPage,
    setPerPage,
    perPage,
    setSearchString,
    searchString,
    currentSearch,
    limitedFilterOptions: LIMITED_FILTER_OPTIONS,
    params,
    setLimitedFilter,
    limitedFilter,
    isLimitedUse,
  };
};

export default useSearchParams;
